/**
 * Inventory Store
 *
 * @since 2018-04-12
 * @author dev014
 */
import Moment from 'moment'
import JSONBigInt from 'json-bigint'
export const state = () => ({
  apiPreFix: '/api/lr/log/',
  logDetailInfoApi: 'detail/security',
  logDetailListApi: 'detail/security/related',
  aptLogDetailListApi: 'detail/security/apt/related',
  // ===  onSearch ===
  search: {
    param: {
      log_type: '',
      log_id: '',
      session_id: '',
      stime: '',
      etime: ''
    }
  },
  detailData: {},
  logListData: []
})

export const mutations = {
  getSearchResult () {}
}
export const actions = {
  // 로그 페이지 결과 조회
  async getSearchResult ({commit, state}) {
    let result = {}
    const param = state.search.param
    const apiUrl = `${state.apiPreFix}${state.logDetailInfoApi}`
    try {
      result = await this.$axios.$get(apiUrl, {params: param, transformResponse: [(data) => { return JSONBigInt.parse(data) }], loading: false})
      if (result.code === 'ok') {
        state.detailData = result.result.result
        commit('getSearchResult', result.result)
      } else {
        state.detailData = {}
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.reason = e
      state.detailData = {}
      return result
    }
  },
  // 로그 페이지 결과 조회
  async getDetailLogList ({commit, state}) {
    let result = {}
    const param = state.search.param
    const apiUrl = `${state.apiPreFix}${state.logDetailListApi}`
    try {
      const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss'
      const stime = Moment(param.etime).add(-1, 'hour').format(DATE_FORMAT)
      const etime = Moment(param.etime).add(1, 'hour').format(DATE_FORMAT)
      result = await this.$axios.$get(apiUrl, {params: {stime: stime, etime: etime, session_id: param.session_id, log_type: param.log_type}, transformResponse: [(data) => { return JSONBigInt.parse(data) }], loading: false})
      if (result.code === 'ok') {
        state.logListData = result.result.log
        commit('getSearchResult', result.result)
      } else {
        state.logListData = []
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.reason = e
      state.logListData = []
      return result
    }
  },
  // AptAttack 로그 관련 로그 테이블 데이터 조회
  async getAptDetailLogList ({commit, state}) {
    let result = {}
    const param = state.search.param
    const apiUrl = `${state.apiPreFix}${state.aptLogDetailListApi}`
    try {
      const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss'
      const stime = Moment(param.etime).add(-1, 'hour').format(DATE_FORMAT)
      const etime = Moment(param.etime).add(1, 'hour').format(DATE_FORMAT)
      const machId = _.isUndefined(state.detailData.mach_id_raw) ? '' : state.detailData.mach_id_raw
      const aptGroupId = _.isUndefined(state.detailData.apt_group_id) ? '' : state.detailData.apt_group_id
      result = await this.$axios.$get(apiUrl, {params: {stime: stime, etime: etime, mach_id: machId, apt_group_id: aptGroupId}, transformResponse: [(data) => { return JSONBigInt.parse(data) }], loading: false})
      if (result.code === 'ok') {
        state.logListData = result.result.log
      } else {
        state.logListData = []
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.reason = e
      state.logListData = []
      return result
    }
  },
  // signature 정보 조회
  async getSignatureInfo ({commit, state}, param) {
    let result = {}
    const apiUrl = `/api/op/ips/profiles/${param.pf_id}/signatures/${param.event_id}/detail?q=lang=${param.lang}`
    try {
      result = await this.$axios.$get(apiUrl)
      return result
    } catch (e) {
      result.code = 'nok'
      result.reason = e
      return result
    }
  }
}

export const getters = {}
export const strict = false
